exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".access-permission_form[data-v-37cba7a6]{padding:15px 0}.access-permission_form .line-separator[data-v-37cba7a6]{margin:10px 0}.access-permission_btns[data-v-37cba7a6]{-ms-grid-columns:(minmax(0,1fr))[1];grid-template-columns:repeat(1,minmax(0,1fr));gap:7px 3.5%;display:-ms-grid;display:grid;-ms-flex-align:end;align-items:end}@media only screen and (min-width:40em) and (max-width:64.063em){.access-permission_btns[data-v-37cba7a6]{-ms-grid-columns:(minmax(0,1fr))[2];grid-template-columns:repeat(2,minmax(0,1fr));gap:26px 3.5%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37cba7a6","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/accessPermission/AccessPermission.vue
// module id = 489e07c53a7a7d144cdd
// module chunks = 76